import type { LucideIcon, LucideProps } from "lucide-react";
import { forwardRef } from "react";

/**
 * Wraps a lucide icon under the name the web code used for its heroicons
 * equivalent (heroicons was dropped for lucide, the one icon set web and admin
 * share). `defaults` sets the look that matches the old icon: a 1.5 stroke for
 * heroicons' outline set, the default 2 (and a fill where the shape reads
 * filled) for its solid set. Anything the caller passes still wins.
 */
export function fromLucide(Icon: LucideIcon, defaults: LucideProps, name: string) {
    const Wrapped = forwardRef<SVGSVGElement, LucideProps>((props, ref) => (
        <Icon ref={ref} aria-hidden="true" {...defaults} {...props} />
    ));
    Wrapped.displayName = name;
    return Wrapped;
}
